import { getStorage, ref, uploadBytes, getDownloadURL, deleteObject } from 'firebase/storage';
import { app } from '../lib/firebase/config';

const storage = getStorage(app);

export const uploadFile = async (file: File, customFileName?: string): Promise<{
  url: string;
  type: 'image' | 'pdf';
  name: string;
}> => {
  try {
    // Use custom file name if provided, otherwise use original name with timestamp
    const fileName = customFileName || `${Date.now()}-${file.name}`;
    
    // Create a reference to the file location
    const storageRef = ref(storage, `documents/${fileName}`);

    // Upload the file
    const snapshot = await uploadBytes(storageRef, file);
    
    // Get download URL
    const downloadURL = await getDownloadURL(snapshot.ref);
    
    // Ensure downloadURL is a string
    if (typeof downloadURL !== 'string') {
      throw new Error('Download URL is not a string');
    }
    
    return {
      url: downloadURL,
      type: file.type.includes('pdf') ? 'pdf' : 'image',
      name: fileName
    };
  } catch (error) {
    console.error('Error uploading file:', error);
    throw new Error('Failed to upload file');
  }
};

export const deleteFile = async (fileUrl: string): Promise<void> => {
  try {
    // Extract the file path from the URL
    const url = new URL(fileUrl);
    const pathParts = url.pathname.split('/').slice(1); // Remove the first empty element
    const filePath = pathParts.join('/');
    
    // Create a reference to the file location
    const fileRef = ref(storage, filePath);
    
    // Delete the file
    await deleteObject(fileRef);
  } catch (error) {
    console.error('Error deleting file:', error);
    throw new Error('Failed to delete file');
  }
};
